import React from 'react';
import dbBack from '../db/back-end';
import BackEndCards from './BackEndCards';

export function BackEnd() {
  return (
    <div className="w-full flex-1 bg-gray-600">
      <div className="mx-auto grid w-full max-w-screen-2xl grid-cols-1 gap-10 px-4 py-10 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 sm:px-6 md:py-14 lg:grid-cols-4 lg:gap-x-6 lg:gap-y-14 lg:px-8 xl:gap-x-8">
        {dbBack.map((value) => (
          <BackEndCards
            key={value.key}
            projectKey={value.key}
            image={value.image}
            link={value.link}
          />
        ))}
      </div>
    </div>
  );
}

export default BackEnd;
